import Artist from "@components/Home/Favourites/Tile/Artist";
import Album from "@components/Home/Favourites/Tile/Album";
import Playlist from "@components/Home/Favourites/Tile/Playlist";
import { useFavourites } from "@hooks/trpc/useFavourites";

const Tile = ({
  favourite,
}: {
  favourite: NonNullable<ReturnType<typeof useFavourites>["data"]>[number];
}) => {
  switch (favourite.collectionType) {
    case "album":
      return <Album album={favourite} />;
    case "artist":
      return <Artist artist={favourite} />;
    case "playlist":
      return <Playlist playlist={favourite} />;
    default:
      return null;
  }
};
export default Tile;
